<div class="kpi-wrapper">
    <app-drake-field [fieldConfig]="f" *ngFor="let f of viewConfig.viewFields" [baseData]="baseData[scope][id]"
        [readonly]="readonly" [mode]="'KPI'">
    </app-drake-field>
</div>